<template>
    <div :is="$route.params.layout === 'mng' ? 'el-card' : 'slot'">
        <el-row :gutter="20">
            <el-col :class="{'deleted':article.deleteYn === 'Y'}" :span="24">
                <el-card shadow="hover">
                <p class="fs18">
                    <span class="pull-right" v-if="boardMst.topNoticeYn !== 'Y' && boardMst.stateYn == 'Y'" :class="pickClass('stateList', article.state)">{{article.state}}</span> 
                    <span v-if="boardMst.categoryYn == 'Y'" class="mr-1" :class="pickClass('categoryList', article.category)">[{{article.category}}]</span> 
                    <span>{{ article.articleTitle }}</span> <i v-if="article.secretYn === 'Y'" class="ml-2 el-icon-lock text-warning font-weight-bold fs18"></i>
                </p>
                <p class="mt-3">
                    <span class="pull-right"><i class="text-medium-gray el-icon-time mr-1"></i> {{ article.createDt | moment('YYYY.MM.DD HH:mm')}}</span>
                    <span><i class="text-medium-gray el-icon-user mr-1"></i> {{article.writerNm}}</span>
                    <span v-if="boardMst.emailYn === 'Y'" class="l-bar"><i class="text-medium-gray el-icon-message mr-1"></i> {{article.writerEmail}}</span>
                    <span v-if="boardMst.readRoleAuthYn === 'Y' && boardMst.isAdmin"  class="l-bar fs11" v-for="item in article.roleSeqSet" >
                        {{item | roleNm}}
                    </span>                    
                </p>

                </el-card>
            </el-col>
        </el-row>


        <el-row class="mt-3" :gutter="20">
            <el-col :span="24">
                <el-card shadow="hover">
                    <div v-if="(articleAttach.length > 0)" class="attach-box mb-3 text-medium-gray"><i class="el-icon-files"></i> 첨부파일 
                        <span class="l-bar" v-for="item in articleAttach" :key="item.attachNo">
                            <a :href="download(item)"><i class="el-icon-paperclip"></i>  {{item.fileNm}}</a>
                        </span>
                    </div>

                    <div v-if="article.htmlYn === 'Y'" v-html="article.articleText"></div>
                    <pre v-if="article.htmlYn !== 'Y'">{{article.articleText}}</pre>
                </el-card>
            </el-col>
        </el-row>

        <el-row v-if="article.replyText" class="mt-3" :gutter="20">
            <el-col :span="24">
                <el-card shadow="hover">

                    <p class="">
                        <span class="fs18 mr-1 text-info" >[답변글]</span> 
                        <span class="pull-right"><i class="text-medium-gray el-icon-time mr-1"></i> {{ article.replyDt | moment('YYYY.MM.DD HH:mm')}}</span>
                        <span><i class="text-medium-gray el-icon-user mr-1"></i> {{article.replyNm}}</span>
                        <span class="l-bar"><i class="text-medium-gray el-icon-message mr-1"></i> {{article.replyEmail}}</span>
                    </p>

                    <div v-if="(replyAttach.length > 0)" class="attach-box mt-3 text-medium-gray"><i class="el-icon-files"></i> 첨부파일 
                        <span class="l-bar" v-for="item in replyAttach" :key="item.attachNo">
                            <a :href="download(item)"><i class="el-icon-paperclip"></i>  {{item.fileNm}}</a>
                        </span>
                    </div>

                    <div class="mt-3" v-html="article.replyText"></div>
                </el-card>
            </el-col>
        </el-row>

        
        <el-row class="mt-5" :gutter="20">
            <el-col :span="24" class="text-center">
                <el-button type="default" icon="el-icon-back" @click="gotoList">목록으로 이동</el-button>
                <el-button v-if="article.canUpdate || article.isNeedPassword" @click="gotoEditBefore" type="primary" icon="el-icon-edit">수 정</el-button>
                <el-button v-if="article.isAdmin && article.topNoticeYn !== 'Y' && boardMst.replyYn == 'Y'" @click="gotoReply"  icon="el-icon-edit">답글작성</el-button>
                <el-button v-if="article.deleteYn === 'N' && (article.canUpdate || article.isNeedPassword)" @click="deleteBefore" type="warning" icon="el-icon-delete">삭 제</el-button>
                <el-button v-if="article.isAdmin && article.deleteYn === 'Y' && (article.canUpdate || article.isNeedPassword)" @click="unDeleteArticle" type="warning" icon="el-icon-refresh">삭제복원</el-button>
                <el-button v-if="article.isAdmin" @click="destroy" type="danger" icon="el-icon-delete">영구삭제</el-button>
            </el-col>
        </el-row>

    </div>

</template>

<script>
import BoardProxy from '@/proxies/BoardProxy'
import PasswordModal from './PasswordModal'
    
export default {
    methods: {
        download( {articleNo, attachNo} ) {

            //location.href = "/api/advertiser/contract/" + row.contractSeq + "/download?authorization=" + $cookies.get('id_token');

            return `/api/board/${this.boardMst.boardNo}/download/${articleNo}/${attachNo}?authorization=${$cookies.get('id_token')}`
        },
        getArticle() {
            return new BoardProxy( )
            .getArticle(this.boardNo, this.articleNo)
            .then(res=> {

                if(res.status == 403) {
                    if(res.needLogin) {
                        alert('게시물을 확인하시려면 로그인이 필요합니다.\n\n로그인 페이지로 이동합니다.')
                        this.$router.push('/home')
                        return
                    }
                    if(res.needPwd) {
                        
                        this.showPwdModal()
                        .then((password)=>{
                            this.confirmPwd( password )
                            .then(this.getArticle)
                        })
                        .catch(()=>{
                            this.$router.push('/home')
                        })
                        return

                    }
                }


                this.article = {...res.item}
                this.articleAttach = [...res.articleAttach]
                this.replyAttach = [...res.replyAttach]


                return res
            })
        },
        pickClass( dest, value ) {

            return (this.boardMst[dest].find(item=>item.value === value) || {}).cls

        },
        gotoReply() {

            this.$router.push({
                name : 'ArticleReply', //`A/board/${this.boardNo}/${row.articleNo}`, 
                params: {
                    boardNo: this.boardNo,
                    articleNo: this.articleNo,
                },
                query: {
                    ...this.$route.query                      
                }
            })

        },
        gotoList() {
            
            this.$router.push({
                name: 'ArticleList',
                query: this.$route.query
            })

        },
        destroy() {

            if(!confirm('영구삭제된 게시물은 복원할 수 없습니다.\n게시글을 영구삭제 할까요?')) return

            new BoardProxy()
            .destroyArticle( this.boardNo, this.articleNo )
            .then((res)=>{
                if(res.header.returnCode == 'OK' ) {
                    alert('영구 삭제 되었습니다.')
                    this.$router.push({
                        name: 'ArticleList',
                        params: { boardNo : this.boardNo }
                    })

                    return
                }
                alert(res.header.resultMessages)

            })

        },
        unDeleteArticle() {

            if(!confirm('게시글을 삭제복원 할까요?')) return

            new BoardProxy()
            .unRemoveArticle( this.boardNo, this.articleNo )
            .then((res)=>{
                if(res.header.returnCode == 'OK' ) {
                    alert('복원 되었습니다.')
                    //this.gotoList()
                    this.getArticle()
                    return
                }
                alert(res.header.resultMessages)

            })
        },
        deleteArticle() {

            if(!confirm('게시글을 삭제할까요?')) return

            new BoardProxy()
            .removeArticle( this.boardNo, this.articleNo )
            .then((res)=>{
                if(res.header.returnCode == 'OK' ) {
                    alert('삭제 되었습니다.')
                    this.$router.push({
                        name: 'ArticleList',
                        params: {
                            boardNo: this.boardNo
                        }    
                    })
                    return
                }
                alert(res.header.resultMessages)

            })
        },
        deleteBefore() {

            if(this.article.isNeedPassword) {
                this.$modal.show(
                    PasswordModal,
                    { handler: (password) => {

                        new BoardProxy()
                        .confirmUpdatePwd( { boardNo: this.boardNo, articleNo: this.articleNo, password } )
                        .then(res=>{
                            if(res.header.returnCode == 'OK' ) {
                                this.deleteArticle()
                                return
                            }
                            alert(res.header.resultMessages)
                        })

                    } },
                    { width: '400px' }
                )

            } else {
                this.deleteArticle()
            }

        },
        gotoEditBefore() {

            if(this.article.isNeedPassword) {
                this.$modal.show(
                    PasswordModal,
                    { handler: (password) => {

                        new BoardProxy()
                        .confirmUpdatePwd( { boardNo: this.boardNo, articleNo: this.articleNo, password } )
                        .then(res=>{
                            if(res.header.returnCode == 'OK' ) {
                                this.gotoEdit()
                                return
                            }
                            alert(res.header.resultMessages)
                        })

                    } },
                    { width: '400px' }
                )

            } else if( this.article.canUpdate ) {
                this.gotoEdit()
            }

        },
        gotoEdit() {
            this.$router.push({
                name : 'ArticleEdit', //`A/board/${this.boardNo}/${row.articleNo}`, 
                params: {
                    boardNo: this.boardNo,
                    articleNo: this.articleNo,
                },
                query: {
                    ...this.$route.query                      
                }
            })

        },
        showPwdModal() {

            return this.$modal.show(
                PasswordModal,
                { handler: (password) => {


                } },
                { width: '400px' }
            ).result


        },
        confirmPwd( password ) {

            return new BoardProxy()
            .confirmReadPwd( { boardNo: this.boardNo, articleNo: this.articleNo, password } )
            .then(res=>{
                if(res.header.returnCode == 'OK' ) {
                    return
                }
                alert(res.header.resultMessages)
            })


        }

    },
    watch: {
    },
    created() {
        this.boardNo = this.$route.params.boardNo
        this.articleNo = this.$route.params.articleNo
        this.getArticle()
        
    },
    computed: {
        boardMst() {
            return this.$store.state.board.boardMst
        }
    },
    data() {
        return {
            articleAttach: [],
            replyAttach: [],
            article: {},
        }
    }

}
</script>

<style scoped>
.bb {border-bottom:1px dotted #eee;}
.attach-box {border-bottom:1px dotted #eee; padding-bottom:10px;}
.deleted * {text-decoration: line-through;} 
</style>